import type { Dictionary } from './functional/dictionary.no-deps'
import type { Nullable, UUID } from './typeHelpers.no-deps'
import { type ConsoleType, useConsoleMethod } from './console.no-deps'

export type Tags = Dictionary<string>
export type Extra = Dictionary<any>

export interface ClientLog {
    logLevel: ConsoleType
    logGroupId?: UUID
    logGroupName?: string
    timestamp: Date
    timeDiff: number
    message: string
    extra?: Extra
    tags?: Tags
    hashpath?: string
}

export interface ClientLogMetadata {
    appVersion: string
    deviceId: Nullable<string>
    browserName: Nullable<string>
    browserVersion: Nullable<string>
    engineName: Nullable<string>
    osName: Nullable<string>
    osVersion: Nullable<string>
    deviceVendor: Nullable<string>
    deviceModel: Nullable<string>
}

export function printLog(log: ClientLog) {
    useConsoleMethod(log.logLevel, `[${log.logGroupName}] ${log.message} ${log.timeDiff}ms`, log)
}

export class LoggableError extends Error {
    constructor(
        message: string,
        public extra?: Extra,
        public tags?: Tags
    ) {
        super(message)
    }
}
